module.exports = __webpack_public_path__ + "static/media/27.54988c93.jpg";